import React from "react";
import { Link } from "react-router-dom";

/** The double-M mountain mark. Uses the uploaded PNG for pixel-accurate brand. */
export default function BrandLogo({ size = 36, withWordmark = true, wordmarkTone = "dark" }) {
    const wordClass =
        wordmarkTone === "light"
            ? "text-white"
            : "text-mm-navy";
    return (
        <Link
            to="/"
            className="group inline-flex items-center gap-3"
            data-testid="brand-logo"
            aria-label="Moving Mountains Advisors — home"
        >
            <span
                className="relative inline-flex items-center justify-center rounded-xl bg-white shadow-card ring-1 ring-mm-line transition-transform duration-300 group-hover:scale-[1.03]"
                style={{ width: size + 8, height: size + 8 }}
            >
                <img
                    src="/brand/logo.png"
                    alt="Moving Mountains mountain mark"
                    width={size}
                    height={size}
                    className="object-contain"
                    style={{ width: size, height: size }}
                />
            </span>
            {withWordmark && (
                <span className="hidden sm:flex flex-col leading-tight">
                    <span className={`mm-display text-[1.05rem] font-semibold ${wordClass}`}>
                        Moving Mountains
                    </span>
                    <span className="text-[0.68rem] uppercase tracking-[0.22em] text-mm-muted">
                        Advisors
                    </span>
                </span>
            )}
        </Link>
    );
}
